export const passcodMessage = {
    FailedCreation : "Failed to create passcode, non success status code"
}
export const generalMessage = {
    Default: "There was an issue communicating with the server, please try again.",     
    EmailValidation : "Maximum of 10 email recipients reached.",
    InputLengthValidation : "Maximum of 500 characters reached.",
}